export const INSURANCE_PROVIDERS = [
  {
    code: "111",
    name: "Všeobecná zdravotní pojišťovna České republiky",
    shortName: "VZP",
    address: "Orlická 2020/4, 130 00 Praha 3",
    email: "",
  },
  {
    code: "201",
    name: "Vojenská zdravotní pojišťovna České republiky",
    shortName: "VoZP",
    address: "Drahobejlova 1404/4, 190 00 Praha 9",
    email: "",
  },
  {
    code: "205",
    name: "Česká průmyslová zdravotní pojišťovna",
    shortName: "ČPZP",
    address: "Jeremenkova 161/11, 703 00 Ostrava-Vítkovice",
    email: "",
  },
  {
    code: "207",
    name: "Oborová zdravotní pojišťovna zaměstnanců bank, pojišťoven a stavebnictví",
    shortName: "OZP",
    address: "Roškotova 1225/1, 140 21 Praha 4",
    email: "",
  },
  {
    code: "209",
    name: "Zaměstnanecká pojišťovna Škoda",
    shortName: "ZPŠ",
    address: "Husova 302, 293 01 Mladá Boleslav",
    email: "",
  },
  {
    code: "211",
    name: "Zdravotní pojišťovna ministerstva vnitra České republiky",
    shortName: "ZPMV",
    address: "Vinohradská 2577/178, 130 00 Praha 3",
    email: "",
  },
  {
    code: "213",
    name: "Revírní bratrská pokladna, zdravotní pojišťovna",
    shortName: "RBP",
    address: "Michálkovická 967/108, 710 00 Ostrava-Slezská Ostrava",
    email: "",
  },
];

export function getInsuranceProviderByCode(code) {
  const key = String(code || "").trim();
  if (!key) return null;
  return INSURANCE_PROVIDERS.find((item) => String(item.code || "").trim() === key) || null;
}
